import isNull from "lodash/isNull";
import { bugNotif } from "../../api/bugsnag";
import { getSubscription } from "../subscription";
import { getErrorMsg } from "../../../Common/utils/common";

declare const klaviyo: {
  identify: (data: {
    email?: string;
    $first_name?: string;
    $last_name?: string;
    $phone_number?: string;
  }) => void;
  push: (event: [string, string, Record<string, unknown>]) => void;
};

export const identifyKlaviyoUserEmail = async (emailAddress: string) => {
  try {
    klaviyo.identify({
      email: emailAddress,
    });
  } catch (error) {
    console.log("error identifyKlaviyoUserEmail", error);
    bugNotif("identifyKlaviyoUserEmail", getErrorMsg(error).rawErrorMsg);
  }
};

export const identifyKlaviyoUserPhone = async (phoneNumber: string) => {
  try {
    klaviyo.identify({
      $phone_number: phoneNumber,
    });
  } catch (error) {
    console.log("error identifyKlaviyoUserPhone", error);
    bugNotif("identifyKlaviyoUserPhone", getErrorMsg(error).rawErrorMsg);
  }
};

export const identifyKlaviyoCompleteProfile = async (
  firstName: string,
  lastName: string,
  phoneNumber: string
) => {
  try {
    klaviyo.identify({
      $first_name: firstName,
      $last_name: lastName,
      $phone_number: phoneNumber,
    });
  } catch (error) {
    console.log("error identifyKlaviyoCompleteProfile", error);
    bugNotif("identifyKlaviyoCompleteProfile", getErrorMsg(error).rawErrorMsg);
  }
};

export const viewProductKlaviyoEvent = async (pid: string) => {
  try {
    const subscription = await getSubscription(pid);
    console.log("subscription", subscription);
    if (isNull(subscription)) {
      console.log("no subscription found");
      throw new Error("No subscription found");
    }

    console.log("will fire klaviyo view product");
    klaviyo.push([
      "track",
      "ViewProduct",
      {
        productId: subscription.docId,
        productName: subscription.name,
      },
    ]);
  } catch (error) {
    console.log("error viewProductKlaviyoEvent", error);
    bugNotif("viewProductKlaviyoEvent", getErrorMsg(error).rawErrorMsg);
  }
};

export const startCheckoutKlaviyoEvent = async (pid: string, value: number) => {
  try {
    const subscription = await getSubscription(pid);
    if (isNull(subscription)) {
      throw new Error("No subscription found");
    }

    klaviyo.push([
      "track",
      "StartCheckout",
      {
        productId: subscription.docId,
        productName: subscription.name,
        value,
        currency: "AUD",
      },
    ]);
  } catch (error) {
    console.log("error startCheckoutKlaviyoEvent", error);
    bugNotif("startCheckoutKlaviyoEvent", getErrorMsg(error).rawErrorMsg);
  }
};

export const addtoCartKlaviyoEvent = async (pid: string, value: number) => {
  try {
    const subscription = await getSubscription(pid);
    if (isNull(subscription)) {
      throw new Error("No subscription found");
    }

    klaviyo.push([
      "track",
      "AddToCart",
      {
        productId: subscription.docId,
        productName: subscription.name,
        value,
        currency: "AUD",
      },
    ]);
  } catch (error) {
    console.log("error addtoCartKlaviyoEvent", error);
    bugNotif("addtoCartKlaviyoEvent", getErrorMsg(error).rawErrorMsg);
  }
};

export const completePurchaseSubscriptionKlaviyoEvent = async (
  pid: string,
  value: number
) => {
  try {
    const subscription = await getSubscription(pid);
    if (isNull(subscription)) {
      throw new Error("No subscription found");
    }

    klaviyo.push([
      "track",
      "CompleteSubscriptionPurchase",
      {
        productId: subscription.docId,
        productName: subscription.name,
        value,
        currency: "AUD",
      },
    ]);
  } catch (error) {
    console.log("error completePurchaseSubscriptionKlaviyoEvent", error);
    bugNotif(
      "completePurchaseSubscriptionKlaviyoEvent",
      getErrorMsg(error).rawErrorMsg
    );
  }
};
